import { render, staticRenderFns } from "./applyAuthority.vue?vue&type=template&id=2f34e452&scoped=true&"
import script from "./applyAuthority.vue?vue&type=script&lang=js&"
export * from "./applyAuthority.vue?vue&type=script&lang=js&"
import style0 from "./applyAuthority.vue?vue&type=style&index=0&id=2f34e452&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34e452",
  null
  
)

export default component.exports